import { z } from 'zod';
import { dateField } from '@shared/schemas';
import { configFloorSchema } from './IConfigFloor';
import { areaViewSchema } from './IAreaView';

// Schemas (source of truth)
export const floorViewSchema = configFloorSchema.extend({
	matchingFixedFloorLastUpdateDate: dateField.optional(),
	isMovingFloorStatic: z.boolean().optional(),
	isMovingFloorStaticChangeDate: dateField.optional(),
	areas: z.array(areaViewSchema),
	tagIds: z.array(z.string()),
});

// Types (derived from schemas)
export type IFloorView = z.infer<typeof floorViewSchema>;
